/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'modest',
    quality: 0.8,
    learning: 1,
    mana: 2,
    magicalGravity: 1.0
}